import { gql } from "@apollo/client";
import { ContentModuleForDisplay } from "components/GuidePreview/types";
import { ContentTemplateForEditorFragment } from "generated/schemaTypes";

export const CONTENT_TEMPLATE_FOR_EDITOR_FRAGMENT = gql`
  fragment ContentTemplateForEditorFragment on ContentTemplate {
    id
    name
    modulesInflated {
      id
      type
      position
      data
    }
  }
`;

type ContentTemplate = ContentTemplateForEditorFragment & {
  resolvedModules?: ContentModuleForDisplay[] | null;
};

export default ContentTemplate;
